var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RumEntityLabel } from '../../observability/rumEntity';
import { ConfirmDialog } from '../common';
export var LockPlanDialog = function (_a) {
    var _b, _c;
    var open = _a.open, scenario = _a.scenario, _d = _a.canUnlock, canUnlock = _d === void 0 ? true : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var t = useTranslation('translation').t;
    var isLocked = !!(scenario === null || scenario === void 0 ? void 0 : scenario.isLocked);
    var showCannotUnlockMessage = isLocked && !canUnlock;
    var lockedByName = (_b = scenario === null || scenario === void 0 ? void 0 : scenario.lockedByUser) === null || _b === void 0 ? void 0 : _b.name;
    var dialogMessage;
    if (showCannotUnlockMessage) {
        dialogMessage = (_jsxs(_Fragment, { children: [lockedByName && (_jsx(Typography, __assign({ component: "span", sx: { display: 'block', fontWeight: 'bold', mb: 2 } }, { children: _jsx(RumEntityLabel, __assign({ kind: "user", id: (_c = scenario === null || scenario === void 0 ? void 0 : scenario.lockedByUser) === null || _c === void 0 ? void 0 : _c.id }, { children: lockedByName })) }))), _jsx(Typography, __assign({ component: "span", sx: { display: 'block' } }, { children: t('confirmation.cannotUnLockDescription') }))] }));
    }
    else if (isLocked) {
        dialogMessage = t('confirmation.descriptionUnLockPlan');
    }
    else {
        dialogMessage = t('confirmation.descriptionLockPlan');
    }
    return (_jsx(ConfirmDialog, { open: open, onClose: onClose, title: showCannotUnlockMessage ? t('confirmation.cannotUnLockTitle') : t('confirmation.title'), message: _jsx(Typography, __assign({ component: "div", sx: { whiteSpace: 'pre-line', color: 'text.primary', textAlign: 'justify' } }, { children: dialogMessage })), cancelButtonText: showCannotUnlockMessage ? 'close' : 'cancel', confirmButtonText: isLocked ? 'continueToUnLock' : 'continueToLock', onConfirm: showCannotUnlockMessage ? undefined : onConfirm, loading: loading }));
};
